import React, { useState } from 'react';
import { Card, Form, Radio, RadioGroup, Row, Col } from 'tea-component';

import KeywordCorrelationComments from '../comments/index';
import Word from './word';

import './index.scss';
import BubbleCommon, {
  keywordCorrelationWordsTips,
} from '@/pages/opinion/components/BubbleCommon';
import { useIntl } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';

export default function Component(props: any) {
  const { formatMessage } = useIntl();

  const {
    keepParams = {},
    keywordCorrelationFilter = {},
    language = 'origin',
  } = props;

  const [position, setPosition] = useState('all');

  const words = [
    {
      title: 'Anchor Words',
      subtitle: 'Mentions Top {top}',
      type: 'head',
    },
    {
      title: 'First Correlation Words',
      subtitle: 'Mentions Top {top}',
      type: 'second',
    },
    {
      title: 'Second Correlation Words',
      subtitle: 'Mentions Top {top}',
      type: 'third',
    },
  ];

  const [selects, setSelects] = useState({
    head: { word: '' },
    second: { word: '' },
    third: { word: '' },
  });

  const handleWordClick = (value: any, type: string) => {
    console.log('handleWordClick', value, type);
  };

  return (
    <CardCommon
      className="dbo-correlation-word"
      title={
        <BubbleCommon tipsMap={keywordCorrelationWordsTips}>
          {formatMessage({ id: 'Words' })}
        </BubbleCommon>
      }
    >
      <>
        <Form className="dbo-correlation-word-radiobox">
          <Form.Item label={formatMessage({ id: 'Position' })}>
            <RadioGroup value={position} onChange={setPosition}>
              <Radio name="all">{formatMessage({ id: 'All' })}</Radio>
              <Radio name="behind">{formatMessage({ id: 'Behind' })}</Radio>
              <Radio name="before">{formatMessage({ id: 'Before' })}</Radio>
            </RadioGroup>
          </Form.Item>
        </Form>

        <Row className="dbo-correlation-wordbox">
          {words.map((item, index) => (
            <Col span={8} key={`${item.title}-${index}`}>
              <Word
                title={formatMessage({ id: item.title })}
                subtitle={
                  '(' + formatMessage({ id: item.subtitle }, { top: 50 }) + ')'
                }
                isEndCard={index === 2}
                type={item.type}
                keepParams={keepParams}
                keywordCorrelationFilter={keywordCorrelationFilter}
                position={position}
                selects={selects}
                setSelects={setSelects}
                language={language}
                handleWordClick={handleWordClick}
              ></Word>
            </Col>
          ))}
        </Row>

        <KeywordCorrelationComments
          selects={selects}
          keepParams={keepParams}
          keywordCorrelationFilter={keywordCorrelationFilter}
          language={language}
        ></KeywordCorrelationComments>
      </>
    </CardCommon>
  );
}
